var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 22,
    height: 22,
    style: {
      borderColor: "rgba(0,0,0,0)",
      borderWidth: "bpx",
      borderStyle: "undefined"
    },
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M512 992C246.896 992 32 777.104 32 512 32 246.896 246.896 32 512 32 777.104 32 992 246.896 992 512 992 777.104 777.104 992 512 992ZM792.832 359.168C780.704 347.04 761.024 347.04 748.896 359.168L447.536 660.528 276.032 489.024C264.16 477.136 244.896 477.136 233.024 489.024 221.136 500.896 221.136 520.16 233.024 532.032L419.664 718.672C421.12 721.584 422.688 724.464 425.12 726.896 437.232 739.024 456.912 739.024 469.04 726.896L792.832 403.104C804.96 390.976 804.96 371.296 792.832 359.168Z",
    "p-id": 7268,
    fill: "rgba(6.885,193.035,150.95999999999998,1)",
    stroke: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSure);
export default __webpack_public_path__ + "static/media/sure.7002a845.svg";
export { ForwardRef as ReactComponent };